// extracted by mini-css-extract-plugin
export var dividerLine = "_7i-3";
export var itemImage = "_7i-9";
export var lightDivider = "_7i-4";
export var modalContent = "_7i-5";
export var modalContentCompact = "_7i-6";
export var productCard = "_7i-a";
export var productImage = "_7i-b";
export var productImageCompact = "_7i-7";
export var productImagePlaceholder = "_7i-c";
export var productImagePlaceholderCompact = "_7i-8";
export var progressBarBackground = "_7i-1";
export var progressBarContainer = "_7i-0";
export var progressBarFill = "_7i-2";